module.exports = __webpack_public_path__ + "img/traffic-sign-3.08b0fe01.png";